<template>
  <div>
    components page3
  </div>
</template>

<script>
export default {
  name: 'componentspage3'
}
</script>

<style lang="stylus" scoped>

</style>
